import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

const ProfileSidebar = ({ isOpen, closeSidebar, user, handleLogout, openCart }) => {
  const navigate = useNavigate();

  if (!user) return null;

  const isAdmin = user.role === 'ADMIN';

  return (
    <>
      {/* Overlay to close sidebar when clicking outside */}
      {isOpen && <div className="overlay" onClick={closeSidebar} style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.5)', zIndex: 2000
      }}></div>}

      <div className={`profile-sidebar ${isOpen ? 'active' : ''}`}>
        
        {/* HEADER */}
        <div className="profile-header">
            <div className="profile-info">
                <div className="profile-avatar">
                    {user.username.charAt(0).toUpperCase()}
                </div>
                <div>
                    <h4 style={{margin:0, fontSize:'1rem'}}>{user.username}</h4>
                    <span style={{fontSize:'0.75rem', opacity:0.8}}>{user.email}</span>
                    {isAdmin && <span style={{display:'block', color:'#f1c40f', fontSize:'0.7rem', fontWeight:'bold', marginTop:'2px'}}>ADMIN ACCESS</span>}
                </div>
            </div>
            <i className="fa-solid fa-xmark close-icon" onClick={closeSidebar}></i>
        </div>

        {/* MENU ITEMS */}
        <div className="profile-menu-list">
            
            {/* 1. MY PROFILE */}
            <div className="profile-menu-item" onClick={() => { navigate('/profile'); closeSidebar(); }}>
                <i className="fa-solid fa-user"></i>
                <span>My Profile</span>
            </div>

            {/* 2. MY ORDERS (Admin ke liye zaroori nahi, par rakh sakte hain) */}
            {!isAdmin && (
                <div className="profile-menu-item" onClick={() => { navigate('/profile'); closeSidebar(); }}>
                    <i className="fa-solid fa-box-open"></i>
                    <span>My Orders</span>
                </div>
            )}

            {/* 3. MY CART */}
            {!isAdmin && (
                <div className="profile-menu-item" onClick={() => { openCart(); closeSidebar(); }}>
                    <i className="fa-solid fa-cart-shopping"></i>
                    <span>My Cart</span>
                </div>
            )}

            {/* --- ADMIN EXCLUSIVE LINKS --- */}
            {isAdmin && (
                <>
                    <div style={{borderTop:'1px solid #eee', margin:'10px 0'}}></div>
                    
                    {/* Admin Dashboard */}
                    <div className="profile-menu-item" onClick={() => { navigate('/admin'); closeSidebar(); }}>
                        <i className="fa-solid fa-chart-line" style={{color:'#e67e22'}}></i>
                        <span style={{fontWeight:'bold', color:'#e67e22'}}>Dashboard</span>
                    </div>

                    {/* Create New Admin (YEH HAI WO BUTTON) */}
                    <div className="profile-menu-item" onClick={() => { navigate('/create-admin'); closeSidebar(); }}>
                        <i className="fa-solid fa-user-plus" style={{color:'#27ae60'}}></i>
                        <span style={{fontWeight:'bold', color:'#27ae60'}}>Create New Admin</span>
                    </div>
                </>
            )}

        </div>

        {/* FOOTER */}
        <div className="profile-footer">
            <button className="logout-btn" onClick={handleLogout}>
                LOGOUT
            </button>
        </div>

      </div>
    </>
  );
};

export default ProfileSidebar;